module.exports = __webpack_public_path__ + "static/media/cdalogo_ri.ab6590f1.png";